var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { width: "100%", outlined: "" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("v-data-table", {
        staticStyle: { width: "100%" },
        attrs: {
          "fixed-header": "",
          items: _vm.configs,
          headers: _vm.headers,
          "hide-default-footer": "",
          "disable-pagination": "",
        },
        scopedSlots: _vm._u([
          {
            key: "item.group",
            fn: function ({ item }) {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "orange--text subtitle-2",
                    attrs: { outlined: "", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.onPressEditGroup(item)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.group) + " ")]
                ),
              ]
            },
          },
          {
            key: "item.meta.uid",
            fn: function ({ item }) {
              return [
                _c(
                  "v-card-text",
                  { staticClass: "blue--text subtitle-2 ma-0 pa-0" },
                  [_vm._v(_vm._s(_vm.getOwner(item)))]
                ),
              ]
            },
          },
          {
            key: "item.meta.updated",
            fn: function ({ item }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm._f("formatDate")(_vm.getUpdated(item))) + " "
                ),
              ]
            },
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "", "max-width": "50%" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { icon: "", color: "orange" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressInfo(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-information"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(item.info?.length > 0 ? item.info : "no info")
                      ),
                    ]),
                  ]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { icon: "", color: "green" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressEdit(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "20" } }, [
                                    _vm._v("mdi-pencil"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Edit")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        icon: "",
                                        color: "teal lighten-1",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDuplicate(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "22" } }, [
                                    _vm._v("mdi-content-copy"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Duplicate")])]
                ),
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { icon: "", color: "red" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onPressDelete(item)
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { size: "20" } }, [
                                    _vm._v("mdi-delete"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v("Delete")])]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }